import React from 'react';
import { ReactComponent as QuoteIcon } from './images/quote.svg';
import pranaPetsSrc from './images/prana-pets.png';
import montKushSrc from './images/mont-kush.png';
import humanFoodBarSrc from './images/human-food-bar.png';
import avatarSrc from './images/avatar.png';
import styles from './OurClients.module.css';

export const OurClients: React.FC = () => (
  <div className={styles.container}>
    <div className={styles.heading}>
      <h3 className={styles.titleKalam}>Our Clients</h3>
      <h2 className={styles.title}>Don't just take our word for it</h2>
    </div>
    <div className={styles.content}>
      <div className={styles.quoteBlock}>
        <QuoteIcon className={styles.quoteIcon} />
        Customers.ai is capturing emails and sending cart and browse abandonment
        emails for people that we do not have in our database. Couldn't ask for
        better support! The additional revenue and 5x ROAS is also amazing.
        <img src={pranaPetsSrc} className={styles.logo} />
      </div>
      <div className={styles.quoteBlock}>
        <QuoteIcon className={styles.quoteIcon} />
        We are very pleased with the ROI from our Customers.ai and Klaviyo
        integration.
        <img src={montKushSrc} className={styles.logo} />
      </div>
      <div className={styles.quoteBlock}>
        <QuoteIcon className={styles.quoteIcon} />
        The difference was incredible. Night and day. Customers.ai has the
        highest quality data on the market.
        <img
          src={avatarSrc}
          className={styles.logo}
          style={{ bottom: '-55px' }}
        />
      </div>
      <div className={styles.quoteBlock}>
        <QuoteIcon className={styles.quoteIcon} />
        I've been a Customers.ai customer and end user for nearly five years,
        and they've consistently been at the forefront of digital marketing
        innovation. Customers.ai's has significantly improved the efficiency of
        our ad spend and email marketing efforts.
        <img src={humanFoodBarSrc} className={styles.logo} />
      </div>
    </div>
  </div>
);
